// import Tab from "bootstrap/js/dist/tab";  
import './Delivery.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
// import CarRentalFaq from "../../../Component/Solutions/CarRentalFaq/CarRentalFaq";
import Tab from "bootstrap/js/dist/tab";  
import AOS from 'aos';
import 'aos/dist/aos.css';
import PopularBlog from '../../../Component/blog/PopularBlog/PopularBlog';


const tabs = ["tabRevenue_1", "tabRevenue_2", "tabRevenue_3"]; // Array of tab IDs

const Delivery = () => {

    const [showWaitlist, setShowWaitlist] = useState(false);

        // START TAB
        useEffect(() => {
            AOS.init({
                duration: 1000,
                offset: 100,
                delay: 500,
                easing: 'ease-in-sine',
                anchorPlacement: 'top-bottom',
            once: false,  
            });
    
            const handleTabShown = () => {
                setTimeout(() => {
                AOS.refresh(); 
                }, 100);
            };
        
            const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');
            tabs.forEach((tab) => {
                tab.addEventListener('shown.bs.tab', handleTabShown);
            });
        
            return () => {
                tabs.forEach((tab) => {
                tab.removeEventListener('shown.bs.tab', handleTabShown);
                });
            };
            
        }, []);
        // END TAB
        
        // START tabRevenue_1 //
        const tabs = ["tabRevenue_1", "tabRevenue_2", "tabRevenue_3"]; // Array of tab IDs
        const [currentTabIndex, setCurrentTabIndex] = useState(0); // Current tab index
    
        useEffect(() => {
          const interval = setInterval(() => {
            const nextTabIndex = (currentTabIndex + 1) % tabs.length; 
            const nextTabId = tabs[nextTabIndex];
    
            const nextTab = new Tab(document.getElementById(nextTabId));
            nextTab.show();
            setCurrentTabIndex(nextTabIndex); 
          }, 10000); // Switch every 5 seconds
      
          return () => clearInterval(interval); 
        }, [currentTabIndex]); 
        // END tabRevenue_1 //
    

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;


   


    return (
        <>
        <AIheader/>
        <BetaWaitlist
        showJoinWaitList={showWaitlist}
        onClose={() => setShowWaitlist(false)}
        onOpen={() => setShowWaitlist(true)}
        />
            {/* START bannerCarRentalMain */}
            <section className="bannerCarRentalMain bannerDeliveryMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                    <div className="col-lg-6">
                            <div className="bannerCarRentalLeft">
                                <small>GIG DELIVERY DRIVERS</small>
                                <h1>Expand your<br/> business by<br/> renting to gig<br/> delivery drivers</h1>
                                <p>The demand for drivers for food and package delivery, or last-mile logistics has never been higher.</p>
                                <div className="carRentalBtn">
                                <button onClick={() => setShowWaitlist(true)} className="btn btnBlue">
                                    Join Waitlist
                                    </button>
                                    <a className="btn btnTransparent" href="/contact-sales">Contact Sales</a>
                                </div> 
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="bannerCarRentalRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Solutions/delivery_banner.webp" alt="GIG DELIVERY DRIVERS"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}

 


            {/* START whyCarRentalMain */}
            <section className="whyCarRentalMain whyCarDeliveryMain">
                <div className="container">
                    <div className="whyCarRentalOuter">   
                        <div className='row align-items-center'>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalLeft'>
                                    <small>INCREASE REVENUE</small>
                                    <h2>Rent to gig<br/> deliver drivers<br/> and maximize<br/> utilization rates.</h2>
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='whyCarRentalRight'>
                                    <ul>
                                        <li>
                                            <h4>High Demand, Constant Need</h4>
                                            <p>Gig economy platforms create a constant need for delivery-ready vehicles. Drivers without personal cars or those looking for reliable rental options turn to fleet operators for long-term access.</p>
                                        </li>
                                        <li>
                                            <h4>Longer Rental Durations, More Revenue</h4>
                                            <p>Unlike traditional short-term rentals, gig drivers rent vehicles for weeks or months at a time, providing steady, predictable income with minimal downtime.</p>
                                        </li>
                                        <li>
                                            <h4>Minimal Wear & Tear Compared to Ride-Share</h4>
                                            <p>While ride-share rentals involve constant passenger use, gig delivery drivers primarily transport goods, reducing interior wear and tear while still maximizing vehicle utilization.</p>
                                        </li>
                                    
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END whyCarRentalMain */}

            {/* START rideshareInsuranceMain */}
            <section className="rideshareInsuranceMain deliveryInsuranceMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="rideShareInsuranceHead">
                                <h2>Ensuring Gig Delivery Driver Compliance</h2> 
                                <p>RentShield provides the right insurance documentation for gig<br/> delivery drivers to work without delays or coverage issues.</p>
                            </div>
                        </div>
                    </div>
                    <div className='rideShareInsuranceOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className='rideShareInsuranceLeft'>
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <a className="nav-link active" id="tabRevenue_1" data-bs-toggle="tab" href="#rideShareInsurance_1">
                                                <h3>Meets Gig Platform Insurance Standards</h3>
                                                <p>Many standard rental policies don’t meet the commercial use requirements for 
                                                    gig work. RentShield ensures full compliance with DoorDash, Uber Eats, Instacart, 
                                                    Amazon Flex, and more.</p>
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="tabRevenue_2" data-bs-toggle="tab" href="#rideShareInsurance_2">
                                                <h3>Driver’s Name on the Policy</h3>
                                                <p>Gig platforms require drivers to have proper insurance documentation in their name. 
                                                    RentShield issues policies that match gig platform requirements so drivers can start.</p>
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" id="tabRevenue_3" data-bs-toggle="tab" href="#rideShareInsurance_3">
                                                <h3>Instant Proof of Coverage</h3>
                                                <p>Digital access means drivers receive immediate proof of insurance, keeping them on 
                                                    the road without delays or verification issues.</p>
                                            </a>
                                        </li>
                                
                                    </ul>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className="tab-content">
                                    {/* START Tab 1 */}
                                    <div className="tab-pane active" id="rideShareInsurance_1">
                                        <div className='rideShareInsuranceRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                                <img className="img-fluid" width="524px" src="/img/Solutions/simple_4.png" alt="ride sharing"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 1 */}

                                    {/* START Tab 2 */}
                                    <div className="tab-pane fade" id="rideShareInsurance_2">
                                        <div className='rideShareInsuranceRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                            <img className="img-fluid" width="510px" src="/img/Solutions/simple_2.png" alt="ride sharing"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 2 */}

                                    {/* START Tab 3 */}
                                    <div className="tab-pane fade" id="rideShareInsurance_3">
                                        <div className='rideShareInsuranceRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                            <img className="img-fluid" width="451px" src="/img/Solutions/simple_3.webp" alt="ride sharing"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 3 */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rideshareInsuranceMain */}


            {/* START choiceFormerMain */}
            <section className='gigDeliveryMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                <h2>Gig delivery driver solutions made simple.</h2>
                                <p>Rentid helps rental operators expand into the gig economy with the right tools, 
                                workflows, and insurance coverage—ensuring drivers stay compliant and rental 
                                vehicles stay profitable.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight" >
                                <img className='img-fluid' src="/img/Solutions/gig_delivery.webp" alt="Gig delivery driver solutions made simple"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Where <span className="grad_1_Span">Rental Workflows & Tools</span> Converge for Gig Delivery Drivers</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent ID"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rentDirect"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Management Platform</h3>
                                                    <p>RentDirect is a complete rental ecosystem for the modern world, integrating customizable workflows and tools tailored with your custom platform settings.</p>
                                                    <p>Practically driving itself with automations, dynamic data, and AI-powered intelligence, RentDirect delivers efficiency, flexibility, and scalable growth—unlike traditional rental software.</p>
                                                </div>        

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Trust & Safety Workflows</h3>
                                                    <p>RentID gives hosts full control over who gets behind the wheel. With AI-driven screening, real-time ID verification, and personal insurance validation, only qualified renters gain access.</p>
                                                    <p>The DriverIQ™ Score assesses risk, while our National BlockList stops repeat offenders. Seamlessly integrated, these security workflows keep rentals safe without delaying bookings.</p>
                                                </div>                                            
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>

                                                <div className='choiceFormerTop'>
                                                    <h3>Coverage & Protection Plans</h3>
                                                    <p>RentShield™ is built into every rental, giving you automatic protection without extra steps. Whether you need liability-only or full physical damage coverage, or roadside assistance, your fleet stays covered—without the need of manual intervention.</p>
                                                </div>



                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Automated Rental Tasks </h3>
                                                    <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything from renter support to booking management, and even your rental policy enforcement so you don’t have to.</p>
                                                    <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rentId"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Rental Back Office Solutions</h3>
                                                    <p>Providing real-time support and structured policy management to help rental operators handle disputes, violations, and claims effortlessly.</p>
                                                    <p>Our expert-backed Resolution Center and rental back office ensure seamless fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Learn, Teach, & Duplicate Hub</h3>
                                                    <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                    <p>We’re here every step of the way!</p>
                                                </div>
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="headChoiceFormer">
                                <h2>Where <span className="grad_1_Span">Rental Workflows & Tools</span> Converge for Gig Delivery Drivers</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent Direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>Rental Management Platform</h3>
                                                <p>RentDirect is a complete rental ecosystem for the modern world, integrating 
                                                customizable workflows and tools tailored with your custom platform settings.</p>
                                                <p>Practically driving itself with automations, dynamic data, and AI-powered 
                                                intelligence, RentDirect delivers efficiency, flexibility, and scalable 
                                                growth—unlike traditional rental software.</p>

                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent ID"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent Id"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                        <h3>Trust & Safety Workflows</h3>
                                                        <p>RentID gives hosts full control over who gets behind the wheel. With AI-driven screening, 
                                                        real-time ID verification, and personal insurance validation, only qualified renters 
                                                        gain access. </p>
                                                        <p>The DriverIQ™ Score assesses risk, while our National BlockList stops repeat offenders. 
                                                        Seamlessly integrated, these security workflows keep rentals safe without 
                                                        delaying bookings.</p>
                                                                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                
                                                        <h3>Coverage & Protection Plans</h3>
                                                        <p>RentShield™ is built into every rental, giving you automatic protection without extra steps. 
                                                            Whether you need liability-only or full physical damage coverage, or roadside assistance, 
                                                            your fleet stays covered—without the need of manual intervention.</p>
                                                


                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent Ai"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent ai"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>

                                                        <h3>Automated Rental Tasks </h3>
                                                        <p>Meet Rentii™ — your AI-powered back-office rental partner handling everything from 
                                                        renter support to booking management, and even your rental policy enforcement so 
                                                        you don’t have to.</p>
                                                        <p>Tap into the power of AI Rental Agent support for your rental business.</p>
                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                <h3>Rental Back Office Solutions</h3>
                                                <p>Providing real-time support and structured policy management to help rental 
                                                    operators handle disputes, violations, and claims effortlessly.</p>
                                                <p>Our expert-backed Resolution Center and rental back office ensure seamless 
                                                    fleet coordination, compliance, and renter management, so you can focus on growth.</p>
                                        
                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                        <h3>Learn, Teach, & Duplicate Hub</h3>
                                                        <p>Whether you’re launching your first rental or managing a growing fleet, RentAcademy™ provides expert-led courses, industry insights, and step-by-step guides to help you run a more profitable rental business.</p>
                                                        <p>We’re here every step of the way!</p>
                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START rentalbackOfficeMain */}
            <section className='rentalbackOfficeMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='rentalbackOfficeHead'>
                                <h6>OPERATIONAL SOLUTIONS</h6>
                                <h2>Rental Back Office</h2>
                                <p> Optimize operations with a fully integrated rental back-office solution that supports your 
                                team and simplifies management. Automated workflows resolve issues faster with a centralized 
                                system that handles the heavy lifting—so you can focus on growth.</p>
                            </div>
                        </div>
                    </div>



                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>AI Rental Agents</h3>
                                <p>AI rental super agent that handles tasks, solves problems, and keeps your business moving.</p>
                                 <a href="/rentai">Learn about AI Rental Agents</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Tolls & Tickets </h3>
                                <p>Automatically track, charge, and manage tolls and violations, ensuring accurate billing.</p>
                                 <a href="/rentsuccess#tolls_and_tickets">Learn about Tolls & Tickets </a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Roadside Assistance </h3>
                                <p>24/7 roadside coverage, including towing, jump-starts, and lockout assistance.</p>
                                <a href="/rentshield#NationalRoadsideAssistance">Learn about Roadside Assistance </a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Guest Communication</h3>
                                <p>Enhance customer experience with automated messages, real-time updates, and instant responses.</p>
                                 <a href="/rentsuccess#OnRentGuidelines">Learn about Guest Communication</a> 
                            </div>
                        </div>

                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Resource Center</h3>
                                <p>Centralized hub for renter education to streamline  operations & reduce inquiries.</p>
                                 <a href="/rentsuccess#BusinessEmpowerment">Learn about Resource Center</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Success Manager</h3>
                                <p>Dedicated support to increase utilization, revenue and grow with expert insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_2">Learn about Success Manager</a>  
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Technical Support</h3>
                                <p>Ensure smooth operations with expert assistance, system integrations and troubleshooting.</p>
                                 <a href="/rentsuccess#TechnicalSupport">Learn about Technical Support</a> 
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='rentalbackOfficeInner'>
                                <h3>Digital Marketing</h3>
                                <p>Attract more renters with targeted campaigns, automated re-marketing, and insights.</p>
                                <a href="/rentsuccess#businessEmpowerment_3">Learn about Digital Marketing</a> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rentalbackOfficeMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
            
            {/* START resolutionAnounceMain */}
            <section className='resolutionAnounceMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='resolutionAnounceHead'>
                                <h6>ADMINISTRATIVE SUPPORT</h6>
                                <h2>Rentid Resolution Center</h2>
                                <p>Managing rental disputes is costly and time-consuming. Rentid’s Resolution Center streamlines incident submission, tracking, and resolution for violations, damages, and claims—all in one platform—with automated invoicing and payment recovery.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row align-items-center'>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceLeft">
                                <div className='row align-items-center'>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>On Rent Guest Violations</h3>
                                            <p>Submit incidents for infractions of the rental agreement, including late returns, 
                                            mileage overages, and vehicle misuse.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Submit Insurance Claims</h3>
                                            <p>Process and track insurance claims directly within the platform, 
                                            reducing paperwork and speeding up resolutions.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Issue Guest Refunds</h3>
                                            <p>Control refunds seamlessly, whether issuing full or partial reimbursements, 
                                            handling approvals, or tracking disputes.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-6'>
                                        <div className='resolutionAnounceInner'>
                                            <h3>Report Guest Behavior</h3>
                                            <p>Report guest behavior to improve risk assessment, prevent future issues, and maintain high rental standards.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="resolutionAnounceBottom">
                                     <a className="btn btnTransparent_5" href="/rentsuccess#ResolutionCenter">Explore The Resolution Center 
                                     <img src="/img/AnoucementPage/arrow-right.svg" alt="icon"/></a>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className="resolutionAnounceRight">
                                <figure>
                                    <img className='img-fluid' src="/img/AnoucementPage/resolutionAnounceRight.png" alt="Rentid Resolution Center"/>
                                </figure>
                            </div>

                        </div>
                    
                    </div>

                </div>
            </section>
            {/* END resolutionAnounceMain */}


            {/* START trackingTelematicsMain */}
            <section className="trackingTelematicsMain">
                <div className="container">
                    <div className='row align-items-center'>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsLeft'>
                                <ul>
                                    <li>
                                        <img className="img-fluid" width="105px" src="/img/AnoucementPage/trackingTelematics_1.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="121px" src="/img/AnoucementPage/trackingTelematics_2.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_3.png" alt="Industry trust and transparency" />
                                    </li>
                                    <li>
                                        <img className="img-fluid" width="123px" src="/img/AnoucementPage/trackingTelematics_4.png" alt="Industry trust and transparency" />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='trackingTelematicsRight'>
                                <h6>INTEGRATIONS</h6>
                                <h2>Tracking and Telematics</h2>
                                <p>Rentid’s built-in telematics provides real-time tracking, driver behavior insights, and remote security controls—without needing third-party systems. Protect your fleet, reduce risk, and optimize vehicle performance, all from one platform.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* END trackingTelematicsMain */}
            <EasySetup/>

            {/* <CarRentalFaq/> */}

            <ScrollingAnounce/>


 
            <PopularBlog/>

            <Footer/>
        </>
    )
}

export default Delivery;